import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID, REDUX_ACTIONS, CURRENT_SAVE_DATA_VERSION } from '../../data/constants';

const initialState = {
  isLoaded: false,
  savedFiles: {},
};

const saveDataReducer = (state = initialState, action) => {
  const { gameId, payload, type } = action;

  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return {
        ...state,
        isLoaded: true,
      };

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      let newsavedFiles = {};

      if (action.stateData) {
        if (action.stateData[GAME_ID]) {
          const { GameData } = action.stateData[GAME_ID];
          if (GameData) {
            const { savedFiles = {}, version = -1 } = GameData;
            if (version >= CURRENT_SAVE_DATA_VERSION) {
              newsavedFiles = { ...savedFiles };
            } else {
              newsavedFiles = state.savedFiles;
            }
          }
        }
      }

      return {
        ...state,
        isLoaded: true,
        savedFiles: newsavedFiles,
      };
    }

    case REDUX_ACTIONS.CLEAR_SAVE_DATA_BY_KEY: {
      const { savedFiles } = state;

      delete savedFiles[payload];

      return {
        ...state,
        savedFiles,
      };
    }

    case REDUX_ACTIONS.SAVE_DATA_BY_KEY: {
      const { data, key } = payload;

      const savedFiles = { ...state.savedFiles };
      savedFiles[key] = data;

      return {
        ...state,
        savedFiles,
      };
    }

    default:
      return state;
  }
};

export default saveDataReducer;
